export default "__VITE_ASSET__gkfkKTNg__"